'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // 记录错误到控制台（含完整堆栈，便于排查 TDZ / 循环依赖）
    console.error('Application error:', error);
    if (error?.stack) console.error('Stack:', error.stack);
  }, [error]);

  // 调试用：TDZ/初始化顺序错误时展示堆栈，便于定位
  const isInitError = error?.message?.includes('before initialization') ?? false;
  const showDetails = process.env.NODE_ENV === 'development' || isInitError;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        marginBottom: '1rem',
        color: '#dc2626'
      }}>
        出现了一些问题
      </h2>
      
      <p style={{
        fontSize: '1rem',
        color: '#6b7280',
        marginBottom: '2rem',
        maxWidth: '500px'
      }}>
        抱歉，应用程序遇到了一个错误。请尝试刷新页面或稍后再试。
      </p>
      
      <div style={{
        display: 'flex',
        gap: '1rem'
      }}>
        <button
          onClick={reset}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#3b82f6',
            color: '#ffffff',
            border: 'none',
            borderRadius: '0.375rem',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#2563eb';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#3b82f6';
          }}
        >
          重试
        </button>
        
        <button
          onClick={() => window.location.href = '/'}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#f3f4f6',
            color: '#374151',
            border: '1px solid #d1d5db',
            borderRadius: '0.375rem',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#e5e7eb';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#f3f4f6';
          }}
        >
          返回首页
        </button>
      </div>
      
      {showDetails && (
        <details style={{
          marginTop: '2rem',
          padding: '1rem',
          backgroundColor: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '0.375rem',
          maxWidth: '600px',
          textAlign: 'left'
        }}>
          <summary style={{
            cursor: 'pointer',
            fontWeight: '500',
            color: '#374151'
          }}>
            错误详情 {isInitError ? '(TDZ/初始化错误)' : '(开发模式)'}
          </summary>
          <pre style={{
            marginTop: '0.5rem',
            fontSize: '0.875rem',
            color: '#dc2626',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
          }}>
            {error.message}
            {error.stack && `\n\n${error.stack}`}
          </pre>
        </details>
      )}
    </div>
  );
}
